import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Nav } from 'react-bootstrap'
import styles from './style.module.scss'

import navStyles from '@shared/components/commonNav/style.module.scss'
import SeriesStatsTabData from './seriesStatsTabData'

const SeriesStats = ({
  seriesData,
  statsDataBattingMostRuns,
  statsDataBattingBestStrikeRate,
  statsDataBowlingMostWickets,
  statsDataBowlingBestEconomyRate
}) => {
  const [selectedStat, setSelectedStat] = useState('Most Runs')
  const mostRunsData = statsDataBattingMostRuns?.fetchSeriesStats
  const bestStrikeData = statsDataBattingBestStrikeRate?.fetchSeriesStats
  const bowlingMostWicketsData = statsDataBowlingMostWickets?.fetchSeriesStats
  const bestEconomyRateData = statsDataBowlingBestEconomyRate?.fetchSeriesStats

  function handleFilter(e) {
    setSelectedStat(e?.target.innerHTML)
  }

  const displaySeriesStatsTab =
    mostRunsData?.length > 0 || bestStrikeData?.length > 0 || bowlingMostWicketsData?.length > 0 || bestEconomyRateData?.length > 0

  return seriesData.length > 0 && displaySeriesStatsTab ? (
    <>
      <h6 className="font-bold mb-0">{'Series Stats'}</h6>
      <Nav
        variant="pills"
        className={`${navStyles.commonNav} scroll-list flex-nowrap text-nowrap px-0 mt-0 `}
        style={{ minHeight: 'auto' }}>
        <Nav.Item className={navStyles.item}>
          <a
            className={`${selectedStat === 'Most Runs' && `${navStyles.active} fw-bold`} pt-0 ${styles.customNavLink}`}
            onClick={handleFilter}>
            Most Runs
          </a>
        </Nav.Item>
        <Nav.Item className={navStyles.item}>
          <a
            className={`${selectedStat === 'Best Strike Rate' && `${navStyles.active} fw-bold`} pt-0 ${styles.customNavLink}`}
            onClick={handleFilter}>
            Best Strike Rate
          </a>
        </Nav.Item>
        <Nav.Item className={navStyles.item}>
          <a
            className={`${selectedStat === 'Most Wickets' && `${navStyles.active} fw-bold`} pt-0 ${styles.customNavLink}`}
            onClick={handleFilter}>
            Most Wickets
          </a>
        </Nav.Item>
        <Nav.Item className={navStyles.item}>
          <a
            className={`${selectedStat === 'Best Economy Rates' && `${navStyles.active} fw-bold`} pt-0 ${styles.customNavLink}`}
            onClick={handleFilter}>
            Best Economy Rates
          </a>
        </Nav.Item>
      </Nav>
      <SeriesStatsTabData
        selectedStat={selectedStat}
        mostRunsData={mostRunsData}
        bestStrikeData={bestStrikeData}
        bowlingMostWicketsData={bowlingMostWicketsData}
        bestEconomyRateData={bestEconomyRateData}
      />
    </>
  ) : null
}

SeriesStats.propTypes = {
  seriesData: PropTypes.array,
  statsDataBattingMostRuns: PropTypes.object,
  statsDataBattingBestStrikeRate: PropTypes.object,
  statsDataBowlingMostWickets: PropTypes.object,
  statsDataBowlingBestEconomyRate: PropTypes.object
}

export default SeriesStats
